class StoreOpenings extends HTMLElement {
  connectedCallback() {
    if (!window.bookingApp?.config?.days || typeof moment === 'undefined') return;

    this.render();
  }

  render() {
    const today = moment(window.bookingApp.today);
    const days = window.bookingApp.config.days;
    const todayName = today.format('dddd');
    const todayConfig = days.find((d) => d.day === todayName) || days[0];
    const currentTime = today.format('HH:mm:ss');
    const isOpen =
      moment(currentTime, 'HH:mm:ss').isSameOrAfter(moment(todayConfig.start, 'HH:mm:ss')) &&
      moment(currentTime, 'HH:mm:ss').isSameOrBefore(moment(todayConfig.close, 'HH:mm:ss'));

    const statusHtml = `
      <div class="">
        <h4 class="z-font-bold">Opening Hours</h4>
        <p class="z-text-gray-500 z-flex z-gap-2">
          <span class="${isOpen ? 'z-text-green-500' : ''}" style="color: ${isOpen ? 'green' : 'red'};">
            ${isOpen ? 'Opened' : 'Closed'}
          </span>
          <span>Closes ${moment(todayConfig.close, 'HH:mm:ss').format('h:mma')}</span>
        </p>
      </div>
    `;

    const listItems = Array.from({ length: 5 }, (_, index) => {
      const date = today.clone().add(index, 'days');
      const dayName = date.format('dddd');
      const config = days.find((d) => d.day === dayName) || todayConfig;
      const isToday = index === 0;

      return `
        <li class="z-flex z-items-center z-py-3 z-border-b z-gap-3${isToday ? ' z-font-bold' : ''}">
          <span>${dayName}</span>
          <span class="z-text-gray-500">${date.format('MMMM D')}</span>
          <span class="z-ml-auto">
            ${moment(config.start, 'HH:mm:ss').format('h:mma')} - ${moment(config.close, 'HH:mm:ss').format('h:mma')}
          </span>
        </li>
      `;
    }).join('');

    this.innerHTML = `
      ${statusHtml}
      <div class="z-mt-5">
        <ul class="opneings_list">${listItems}</ul>
      </div>
    `;
  }
}

customElements.define('store-openings', StoreOpenings);
